// removed by extract-text-webpack-plugin
module.exports = {"container":"fy_g","containerColumns":"fy_fj","tagLine":"fy_fz","subheading":"fy_fe","subheadingDescription":"fy_f0","checkbox":"fy_f1","item":"fy_fl","items":"fy_fk","itemLeftColumn":"fy_f2","itemMainColumn":"fy_f3","tag":"fy_cn"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/MemberBenefits/styles.module.css
// module id = 1221
// module chunks = 27